import * as React from 'react';
import clsx from 'clsx';
import { routes } from 'routes';
import './style.scss';

import {
    Button,
    Icons,
    IButtonProps,
    Panel,
    PanelBody,
    CloseButton,
    LinkButton,
    AnchorLinkButton
} from 'components';
import { UserMenuItems } from './menu';

export interface IUserMenuProps {
    open: boolean;
    onOpen: () => any;
    onClose: () => any;
    buttonProps?: IButtonProps;

}
export interface IUserMenuState {}

class UserMenuComponent extends React.Component<IUserMenuProps, IUserMenuState> {
    constructor(props: IUserMenuProps) {
        super(props);

        this.handleFavClick = this.handleFavClick.bind(this);
    }

    handleFavClick() {
        const { onClose } = this.props;
        routes.redirect(routes.favourites);
        onClose();
    }

    handleCMSClick() {
        const objUrl = new URL(`${window.location.protocol}//${__HOST__}/`);
        const url = `${objUrl.origin}/cms/`;
        window.open(url, '_blank');
    }

    render() {
        if (!this.props.open) {
            return (
                <Button
                    onClick={this.props.onOpen}
                    icon={<Icons.IconMenu />}
                />
            );
        } else {
            return (
                <Panel className="user-menu-panel">
                    <PanelBody className="user-menu-panel-body">
                        <CloseButton
                            onClick={this.props.onClose}
                        />
                        <UserMenuItems
                            onFavClick={this.handleFavClick}
                            onCMSClick={this.handleCMSClick}
                        />
                    </PanelBody>
                </Panel>
            );
        }
    }
}

export const UserMenu = UserMenuComponent;
